import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Container, Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useDialog } from "../../../../helpers/useDialog";
import Select from "react-select";
import PageSpinner from "../../../common/PageSpinner";
import { BHAREE_BASE_URL_LOCAL } from "../../../../config/config.url";
import axios from "axios";
import CustomTable from "../../common/CustomTable";
import { tableStructures } from "../../../../helpers/table-structures";
import { getUserSubscription } from "../../../../actions/user.actions";
import { capitalize } from "lodash";
import bhareeBlack from "../../../../assets/images/BhareeBlack.png";
import TimestampConverter from "../../../../utils/TimestampConverter";
import { boosterFeatures, leadsFeatures, starterFeatures } from "../../../../helpers";
import isEmpty from "../../../../utils/is-Empty";
import { useNavigate } from "react-router-dom";

const SellerSubscription = ({ title = "Subscription Details", userId, userObj }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { alert, confirm, DialogModal } = useDialog();
  const [loading, setLoading] = useState(false);
  const [mySubscription, setMySubscription] = useState(null);
  const [subscriptionFeatures, setSubscriptionFeatures] = useState([]);

  const { userSubscriptionInfo } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    setLoading(true);
    getUserSubscription(userId, dispatch).finally(() => {
      setLoading(false);
    });
  }, [userId, dispatch]);

  useEffect(() => {
    // console.log("userSubscriptionInfo: ", userSubscriptionInfo);
    if (userSubscriptionInfo && userSubscriptionInfo.data) {
      setMySubscription(userSubscriptionInfo.data);
    }
  }, [userSubscriptionInfo]);

  useEffect(() => {
    if (!isEmpty(mySubscription) && !isEmpty(mySubscription?.plan_details?.plan_type)) {
      if (mySubscription?.plan_details?.plan_type === "booster") {
        setSubscriptionFeatures(boosterFeatures);
      } else if (mySubscription?.plan_details?.plan_type === "starter") {
        setSubscriptionFeatures(starterFeatures);
      } else if (mySubscription?.plan_details?.plan_type === "leads") {
        setSubscriptionFeatures(leadsFeatures);
      } else {
        setSubscriptionFeatures([]);
      }
    }
  }, [mySubscription]);

  return (
    <>
      {DialogModal}
      {loading && <PageSpinner />}
      {!loading && !isEmpty(mySubscription?.id) && mySubscription?.is_subscription_active && (
        <Container fluid className="py-3 bg-white">
          <Row>
            <Col className="col-12 col-sm-6 col-md-4">
              <div className="my-2 p-3 border rounded bg-white">
                <h5>
                  <strong>Current Subscription</strong>
                </h5>
                <div class="d-inline-flex align-items-center px-4 py-2 mb-1 border border-warning rounded-pill">
                  <Image
                    src={bhareeBlack}
                    alt="Bharee Logo"
                    className="starter-img"
                    style={{
                      height: "15px",
                      objectFit: "contain",
                      marginRight: "10px",
                      marginTop: "-3px",
                    }}
                  />
                  <span class="fw-bold text-danger starter-text">
                    {capitalize(mySubscription?.plan_details?.plan_type)}
                  </span>
                </div>
                <p className="mb-1">
                  <strong>{mySubscription?.plan_details?.plan_title}</strong>
                  <br />
                  {mySubscription?.plan_details?.plan_subtitle}
                </p>
                <p className="mb-1 small">
                  <strong>Subscription ID:</strong> {mySubscription?.id}
                </p>
                <hr />
                <p className="mb-1 small">
                  <strong>Customer ID:</strong> {mySubscription?.customer_id}
                </p>
                <p className="mb-1 small">
                  <strong>Plan ID:</strong> {mySubscription?.plan_id}
                </p>
                <p className="mb-1">
                  <strong>Status:</strong>{" "}
                  <span className="text-success fw-bold">
                    {mySubscription?.status?.toUpperCase()}
                  </span>
                </p>
                <p className="mb-1 small">
                  <strong>Start Date:</strong>{" "}
                  {TimestampConverter(mySubscription?.current_start * 1000)}
                </p>
                <p className="mb-1 small">
                  <strong>Next Billing Date:</strong>{" "}
                  {TimestampConverter(mySubscription?.next_billing_date)}
                </p>

                {!isEmpty(subscriptionFeatures) && subscriptionFeatures?.length > 0 && (
                  <>
                    <hr />
                    <h5 className="mb-1">
                      <strong>Features</strong>
                    </h5>
                    {subscriptionFeatures?.map(([label, value], index) => (
                      <Row key={index} className="mb-0">
                        <Col md={6} xs={6} className="text-end small muted">
                          {label}
                        </Col>
                        <Col md={6} xs={6} className="text-start">
                          {value?.toLowerCase() === "yes" ? (
                            <i className="bi bi-check-lg text-success"></i>
                          ) : value?.toLowerCase() === "no" ? (
                            <i className="bi bi-x-lg text-danger"></i>
                          ) : (
                            <span className="small">{value}</span>
                          )}
                        </Col>
                      </Row>
                    ))}
                  </>
                )}
              </div>
            </Col>

            <Col className="col-12 col-sm-6 col-md-8">
              <div className="my-2 border rounded">
                {mySubscription?.invoices && mySubscription?.invoices?.length > 0 ? (
                  <CustomTable
                    className="rounded"
                    enableRowActions
                    data={mySubscription?.invoices}
                    enableTopToolbar={true}
                    enableBottomToolbar={true}
                    enablePagination={true}
                    enableFilters={false}
                    emptyTableMsg={`No invoices found`}
                    positionActionsColumn={"last"}
                    columns={tableStructures.subscription_invoices}
                    initialState={{
                      columnPinning: {
                        right: ["mrt-row-actions"],
                      },
                    }}
                    renderTopToolbarCustomActions={({ table }) => (
                      <Row style={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}>
                        <h4>Invoices</h4>
                      </Row>
                    )}
                    renderRowActions={({ row, table }) => (
                      <div className="table-action-box">
                        <Button
                          buttonClasses="action-button text-white"
                          id={row.original.id}
                          onClick={() => {
                            window.open(
                              `/seller/subscription/invoice/${row.original.id}?qid=${userId}`,
                              "_blank"
                            );
                          }}
                        >
                          <i className="bi bi-download"></i>
                        </Button>
                      </div>
                    )}
                  />
                ) : (
                  <p>No invoices available.</p>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      )}
      {!loading && (isEmpty(mySubscription?.id) || !mySubscription?.is_subscription_active) && (
        <Container fluid className="py-3 bg-white">
          <Row>
            <Col md={12} className="text-start">
              <h5>Business Name: {mySubscription?.sellerInfo?.business_name}</h5>
            </Col>
            <Col md={12} className="text-start">
              The user is not subscribed to any paid plan.
            </Col>
            <Col md={12} className="text-start">
              Is Trial: {mySubscription?.sellerInfo?.is_trial ? "Yes" : "No"}
            </Col>
            <Col md={12} className="text-start">
              Trial Start Date: {TimestampConverter(mySubscription?.sellerInfo?.trial_start_date)}
            </Col>
            <Col md={12} className="text-start">
              Trial End Date: {TimestampConverter(mySubscription?.sellerInfo?.trial_end_date)}
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};

export default SellerSubscription;
